import { constants, Flex, icons } from '@inlight-media/linfox-ui-library';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const { ArrowFilled } = icons;

const SortableColumn = ({ label, isDescending, onSortChange, isActive }) => {
  return (
    <Wrapper isActive={isActive}>
      <IconWrapper
        style={{ transform: isDescending ? 'rotate(0deg)' : 'rotate(-180deg)' }}
        onClick={() => {
          onSortChange(!isDescending);
        }}
      >
        <ArrowFilled fill={isActive ? constants.colors.greyEight : constants.colors.greyFive} />
      </IconWrapper>
      {label}
    </Wrapper>
  );
};

const IconWrapper = styled((props) => <div {...props} />)`
  height: 1.5em;
  width: 1.5em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 0.5em;
`;

const Wrapper = styled(Flex)`
  color: ${({ isActive, theme }) => (isActive ? theme.colors.greyEight : theme.colors.greyFive)};
  align-items: center;
`;

SortableColumn.propTypes = {
  label: PropTypes.string.isRequired,
  isDescending: PropTypes.bool,
  onSortChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

SortableColumn.defaultProps = {
  isDescending: true,
  isActive: false,
};

export { SortableColumn };
